import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_region_location_link_RowClass } from '../../../../dbschema';

export class RegionLocationLinkContainerModel extends BaseContainerModel {
    bl_del_region_comp_branch_location_link: bl_del_region_location_link_RowClass = new bl_del_region_location_link_RowClass();
}